// Traductions Postinity — onglets « Ma bougie » et « Mes garants ».
const fr = {
  b_step_photo: "Photo", b_step_identity: "Identité", b_step_message: "Message",
  b_intro: "Renseignez les informations de la bougie, exactement comme lors de la création d'une bougie sur le site.",
  b_photo_hint: "Photo de la bougie (par défaut : votre photo de profil) · max 3 Mo",
  b_name: "Nom (ou prénom)", b_name_ph: "Nom de la personne honorée",
  b_birth: "Date de naissance", b_death: "Date de décès",
  b_nationality: "Nationalité", b_choose: "— Choisir —",
  b_message: "Message / hommage", b_message_ph: "Laisser un message à toutes les personnes qui vont vous écrire",
  g_step_designate: "Désigner", g_step_send: "Envoyer les liens", g_step_publish: "Publication",
  g_why_title: "Pourquoi désigner des garants ?",
  g_why_1: "Vos garants sont vos personnes de confiance.",
  g_why_2: "Le moment venu, ce sont vos trois garants qui confirment le décès, grâce à un lien sécurisé reçu par e-mail. Après contrôle, l'administrateur Postinity enverra les messages enregistrés.",
  g_why_3: "Vous pouvez modifier vos garants à tout moment.",
  g_designate_3: "Désignez vos 3 personnes garantes", g_guarantor: "Garant",
  g_name: "Nom", g_name_ph: "Prénom Nom", g_email: "E-mail", g_email_ph: "email@exemple.fr",
  g_link_sent: "Lien envoyé", g_copy_link: "Copier le lien", g_clear: "Effacer",
  gp_title: "Aperçu de l'e-mail envoyé à vos garants",
  gp_hello: "Bonjour",
  gp_name_ph: "[Prénom du garant]",
  gp_designated: "vous a désigné(e) comme personne garante de sa bougie du souvenir.",
  gp_unique: "🔒 Ce lien est unique et strictement personnel : il vous est réservé. Ne le partagez avec personne.",
  gp_three: "Le moment venu, la confirmation du décès nécessite obligatoirement l'activation des trois personnes garantes. Chaque garant reçoit son propre lien sécurisé et doit confirmer de son côté.",
  gp_thanks: "Grâce à ce lien, vous pourrez confirmer le décès le moment venu :",
  gp_access: "Accéder à l'hommage",
  gp_free: "✅ L'ensemble de la démarche est entièrement gratuit et strictement confidentiel.",
  gp_keep: "Conservez ce lien précieusement.",
  gp_send: "Confirmer l'envoi aux garants",
  gp_you: "Vous",
  ga_guard: "Validez d'abord toutes les étapes (tout doit être vert) avant d'activer vos garants.",
  ga_confirm_send: "Confirmez-vous l'envoi de cet e-mail à toutes vos personnes garantes ? (2ᵉ confirmation)",
};
const en = {
  b_step_photo: "Photo", b_step_identity: "Identity", b_step_message: "Message",
  b_intro: "Fill in the candle's information, exactly as when creating a candle on the site.",
  b_photo_hint: "Candle photo (default: your profile picture) · max 3 MB",
  b_name: "Name (or first name)", b_name_ph: "Name of the honored person",
  b_birth: "Date of birth", b_death: "Date of passing",
  b_nationality: "Nationality", b_choose: "— Choose —",
  b_message: "Message / tribute", b_message_ph: "Leave a message for everyone who will write to you",
  g_step_designate: "Designate", g_step_send: "Send the links", g_step_publish: "Publication",
  g_why_title: "Why designate guardians?",
  g_why_1: "Your guardians are your trusted people.",
  g_why_2: "When the time comes, your three guardians confirm the passing, via a secure link received by email. After verification, the Postinity administrator will send the recorded messages.",
  g_why_3: "You can change your guardians at any time.",
  g_designate_3: "Designate your 3 guardians", g_guarantor: "Guardian",
  g_name: "Name", g_name_ph: "First name Last name", g_email: "Email", g_email_ph: "email@example.com",
  g_link_sent: "Link sent", g_copy_link: "Copy link", g_clear: "Clear",
  gp_title: "Preview of the email sent to your guardians",
  gp_hello: "Hello",
  gp_name_ph: "[Guardian's first name]",
  gp_designated: "has designated you as a guardian of their memorial candle.",
  gp_unique: "🔒 This link is unique and strictly personal: it is reserved for you. Do not share it with anyone.",
  gp_three: "When the time comes, confirming the passing requires the activation of all three guardians. Each guardian receives their own secure link and must confirm on their side.",
  gp_thanks: "With this link, you will be able to confirm the passing when the time comes:",
  gp_access: "Access the tribute",
  gp_free: "✅ The entire process is completely free and strictly confidential.",
  gp_keep: "Keep this link safe.",
  gp_send: "Confirm sending to guardians",
  gp_you: "You",
  ga_guard: "First validate all steps (everything must be green) before activating your guardians.",
  ga_confirm_send: "Do you confirm sending this email to all your guardians? (2nd confirmation)",
};
const es = {
  b_step_photo: "Foto", b_step_identity: "Identidad", b_step_message: "Mensaje",
  b_intro: "Completa la información de la vela, igual que al crear una vela en el sitio.",
  b_photo_hint: "Foto de la vela (por defecto: tu foto de perfil) · máx. 3 MB",
  b_name: "Nombre (o nombre de pila)", b_name_ph: "Nombre de la persona homenajeada",
  b_birth: "Fecha de nacimiento", b_death: "Fecha de fallecimiento",
  b_nationality: "Nacionalidad", b_choose: "— Elegir —",
  b_message: "Mensaje / homenaje", b_message_ph: "Deja un mensaje para todas las personas que te escribirán",
  g_step_designate: "Designar", g_step_send: "Enviar los enlaces", g_step_publish: "Publicación",
  g_why_title: "¿Por qué designar garantes?",
  g_why_1: "Tus garantes son tus personas de confianza.",
  g_why_2: "Llegado el momento, tus tres garantes confirman el fallecimiento mediante un enlace seguro recibido por correo. Tras la comprobación, el administrador de Postinity enviará los mensajes guardados.",
  g_why_3: "Puedes modificar tus garantes en cualquier momento.",
  g_designate_3: "Designa a tus 3 garantes", g_guarantor: "Garante",
  g_name: "Nombre", g_name_ph: "Nombre Apellido", g_email: "Correo", g_email_ph: "correo@ejemplo.com",
  g_link_sent: "Enlace enviado", g_copy_link: "Copiar enlace", g_clear: "Borrar",
  gp_title: "Vista previa del correo enviado a tus garantes",
  gp_hello: "Hola",
  gp_name_ph: "[Nombre del garante]",
  gp_designated: "te ha designado como persona garante de su vela del recuerdo.",
  gp_unique: "🔒 Este enlace es único y estrictamente personal: está reservado para ti. No lo compartas con nadie.",
  gp_three: "Llegado el momento, la confirmación del fallecimiento requiere obligatoriamente la activación de los tres garantes. Cada garante recibe su propio enlace seguro y debe confirmar por su parte.",
  gp_thanks: "Con este enlace, podrás confirmar el fallecimiento llegado el momento:",
  gp_access: "Acceder al homenaje",
  gp_free: "✅ Todo el proceso es totalmente gratuito y estrictamente confidencial.",
  gp_keep: "Guarda este enlace con cuidado.",
  gp_send: "Confirmar el envío a los garantes",
  gp_you: "Tú",
  ga_guard: "Valida primero todas las etapas (todo debe estar en verde) antes de activar tus garantes.",
  ga_confirm_send: "¿Confirmas el envío de este correo a todos tus garantes? (2ª confirmación)",
};
const de = {
  b_step_photo: "Foto", b_step_identity: "Identität", b_step_message: "Nachricht",
  b_intro: "Geben Sie die Informationen der Kerze ein, genau wie beim Erstellen einer Kerze auf der Website.",
  b_photo_hint: "Foto der Kerze (Standard: Ihr Profilbild) · max. 3 MB",
  b_name: "Name (oder Vorname)", b_name_ph: "Name der geehrten Person",
  b_birth: "Geburtsdatum", b_death: "Sterbedatum",
  b_nationality: "Nationalität", b_choose: "— Wählen —",
  b_message: "Nachricht / Hommage", b_message_ph: "Hinterlassen Sie eine Nachricht für alle, die Ihnen schreiben werden",
  g_step_designate: "Benennen", g_step_send: "Links senden", g_step_publish: "Veröffentlichung",
  g_why_title: "Warum Bürgen benennen?",
  g_why_1: "Ihre Bürgen sind Ihre Vertrauenspersonen.",
  g_why_2: "Wenn es so weit ist, bestätigen Ihre drei Bürgen den Tod über einen sicheren Link per E-Mail. Nach der Prüfung sendet der Postinity-Administrator die gespeicherten Nachrichten.",
  g_why_3: "Sie können Ihre Bürgen jederzeit ändern.",
  g_designate_3: "Benennen Sie Ihre 3 Bürgen", g_guarantor: "Bürge",
  g_name: "Name", g_name_ph: "Vorname Nachname", g_email: "E-Mail", g_email_ph: "email@beispiel.de",
  g_link_sent: "Link gesendet", g_copy_link: "Link kopieren", g_clear: "Löschen",
  gp_title: "Vorschau der E-Mail an Ihre Bürgen",
  gp_hello: "Hallo",
  gp_name_ph: "[Vorname des Bürgen]",
  gp_designated: "hat Sie als Bürgen seiner Gedenkkerze benannt.",
  gp_unique: "🔒 Dieser Link ist einzigartig und streng persönlich: er ist für Sie reserviert. Teilen Sie ihn mit niemandem.",
  gp_three: "Wenn es so weit ist, erfordert die Bestätigung des Todes zwingend die Aktivierung aller drei Bürgen. Jeder Bürge erhält seinen eigenen sicheren Link und muss selbst bestätigen.",
  gp_thanks: "Mit diesem Link können Sie den Tod bestätigen, wenn es so weit ist:",
  gp_access: "Zur Hommage",
  gp_free: "✅ Der gesamte Vorgang ist völlig kostenlos und streng vertraulich.",
  gp_keep: "Bewahren Sie diesen Link sorgfältig auf.",
  gp_send: "Senden an Bürgen bestätigen",
  gp_you: "Sie",
  ga_guard: "Bestätigen Sie zuerst alle Schritte (alles muss grün sein), bevor Sie Ihre Bürgen aktivieren.",
  ga_confirm_send: "Bestätigen Sie den Versand dieser E-Mail an alle Ihre Bürgen? (2. Bestätigung)",
};
const it = {
  b_step_photo: "Foto", b_step_identity: "Identità", b_step_message: "Messaggio",
  b_intro: "Inserisci le informazioni della candela, esattamente come nella creazione di una candela sul sito.",
  b_photo_hint: "Foto della candela (predefinita: la tua foto profilo) · max 3 MB",
  b_name: "Nome (o nome proprio)", b_name_ph: "Nome della persona onorata",
  b_birth: "Data di nascita", b_death: "Data del decesso",
  b_nationality: "Nazionalità", b_choose: "— Scegli —",
  b_message: "Messaggio / omaggio", b_message_ph: "Lascia un messaggio per tutte le persone che ti scriveranno",
  g_step_designate: "Designare", g_step_send: "Inviare i link", g_step_publish: "Pubblicazione",
  g_why_title: "Perché designare dei garanti?",
  g_why_1: "I tuoi garanti sono le tue persone di fiducia.",
  g_why_2: "Al momento opportuno, i tuoi tre garanti confermano il decesso tramite un link sicuro ricevuto via email. Dopo la verifica, l'amministratore Postinity invierà i messaggi salvati.",
  g_why_3: "Puoi modificare i tuoi garanti in qualsiasi momento.",
  g_designate_3: "Designa i tuoi 3 garanti", g_guarantor: "Garante",
  g_name: "Nome", g_name_ph: "Nome Cognome", g_email: "Email", g_email_ph: "email@esempio.it",
  g_link_sent: "Link inviato", g_copy_link: "Copia il link", g_clear: "Cancella",
  gp_title: "Anteprima dell'email inviata ai tuoi garanti",
  gp_hello: "Ciao",
  gp_name_ph: "[Nome del garante]",
  gp_designated: "ti ha designato come garante della sua candela del ricordo.",
  gp_unique: "🔒 Questo link è unico e strettamente personale: è riservato a te. Non condividerlo con nessuno.",
  gp_three: "Al momento opportuno, la conferma del decesso richiede obbligatoriamente l'attivazione dei tre garanti. Ogni garante riceve il proprio link sicuro e deve confermare dalla sua parte.",
  gp_thanks: "Con questo link potrai confermare il decesso al momento opportuno:",
  gp_access: "Accedi all'omaggio",
  gp_free: "✅ L'intero processo è completamente gratuito e strettamente riservato.",
  gp_keep: "Conserva questo link con cura.",
  gp_send: "Conferma l'invio ai garanti",
  gp_you: "Tu",
  ga_guard: "Convalida prima tutte le fasi (tutto deve essere verde) prima di attivare i tuoi garanti.",
  ga_confirm_send: "Confermi l'invio di questa email a tutti i tuoi garanti? (2ª conferma)",
};
const pl = {
  b_step_photo: "Zdjęcie", b_step_identity: "Tożsamość", b_step_message: "Wiadomość",
  b_intro: "Uzupełnij informacje o świecy, dokładnie jak przy tworzeniu świecy na stronie.",
  b_photo_hint: "Zdjęcie świecy (domyślnie: Twoje zdjęcie profilowe) · maks. 3 MB",
  b_name: "Imię (lub nazwisko)", b_name_ph: "Imię osoby upamiętnionej",
  b_birth: "Data urodzenia", b_death: "Data śmierci",
  b_nationality: "Narodowość", b_choose: "— Wybierz —",
  b_message: "Wiadomość / hołd", b_message_ph: "Zostaw wiadomość dla wszystkich, którzy do Ciebie napiszą",
  g_step_designate: "Wyznacz", g_step_send: "Wyślij linki", g_step_publish: "Publikacja",
  g_why_title: "Po co wyznaczać gwarantów?",
  g_why_1: "Twoi gwaranci to Twoje zaufane osoby.",
  g_why_2: "Gdy nadejdzie czas, trzej gwaranci potwierdzają śmierć za pomocą bezpiecznego linku otrzymanego e-mailem. Po weryfikacji administrator Postinity wyśle zapisane wiadomości.",
  g_why_3: "Możesz zmienić gwarantów w dowolnej chwili.",
  g_designate_3: "Wyznacz 3 gwarantów", g_guarantor: "Gwarant",
  g_name: "Imię", g_name_ph: "Imię Nazwisko", g_email: "E-mail", g_email_ph: "email@przyklad.pl",
  g_link_sent: "Link wysłany", g_copy_link: "Kopiuj link", g_clear: "Wyczyść",
  gp_title: "Podgląd e-maila wysłanego do gwarantów",
  gp_hello: "Dzień dobry",
  gp_name_ph: "[Imię gwaranta]",
  gp_designated: "wyznaczył(a) Cię na gwaranta swojej świecy pamięci.",
  gp_unique: "🔒 Ten link jest unikalny i ściśle osobisty: jest zarezerwowany dla Ciebie. Nie udostępniaj go nikomu.",
  gp_three: "Gdy nadejdzie czas, potwierdzenie śmierci wymaga obowiązkowo aktywacji wszystkich trzech gwarantów. Każdy gwarant otrzymuje własny bezpieczny link i musi potwierdzić ze swojej strony.",
  gp_thanks: "Dzięki temu linkowi będziesz mógł potwierdzić śmierć, gdy nadejdzie czas:",
  gp_access: "Przejdź do hołdu",
  gp_free: "✅ Cały proces jest całkowicie bezpłatny i ściśle poufny.",
  gp_keep: "Zachowaj ten link starannie.",
  gp_send: "Potwierdź wysyłkę do gwarantów",
  gp_you: "Ty",
  ga_guard: "Najpierw zatwierdź wszystkie etapy (wszystko musi być zielone) przed aktywacją gwarantów.",
  ga_confirm_send: "Czy potwierdzasz wysłanie tego e-maila do wszystkich gwarantów? (2. potwierdzenie)",
};
const fil = {
  b_step_photo: "Larawan", b_step_identity: "Pagkakakilanlan", b_step_message: "Mensahe",
  b_intro: "Punan ang impormasyon ng kandila, tulad ng paggawa ng kandila sa site.",
  b_photo_hint: "Larawan ng kandila (default: iyong profile picture) · max 3 MB",
  b_name: "Pangalan (o unang pangalan)", b_name_ph: "Pangalan ng pinaparangalan",
  b_birth: "Petsa ng kapanganakan", b_death: "Petsa ng pagpanaw",
  b_nationality: "Nasyonalidad", b_choose: "— Pumili —",
  b_message: "Mensahe / parangal", b_message_ph: "Mag-iwan ng mensahe para sa lahat ng susulat sa iyo",
  g_step_designate: "Italaga", g_step_send: "Ipadala ang mga link", g_step_publish: "Paglalathala",
  g_why_title: "Bakit magtalaga ng mga tagapangalaga?",
  g_why_1: "Ang iyong mga tagapangalaga ay iyong pinagkakatiwalaang tao.",
  g_why_2: "Sa takdang panahon, kinukumpirma ng tatlong tagapangalaga ang pagpanaw sa pamamagitan ng ligtas na link na natanggap sa email. Pagkatapos ng pagsusuri, ipapadala ng administrator ng Postinity ang mga naka-save na mensahe.",
  g_why_3: "Maaari mong baguhin ang mga tagapangalaga anumang oras.",
  g_designate_3: "Italaga ang iyong 3 tagapangalaga", g_guarantor: "Tagapangalaga",
  g_name: "Pangalan", g_name_ph: "Pangalan Apelyido", g_email: "Email", g_email_ph: "email@halimbawa.com",
  g_link_sent: "Naipadala ang link", g_copy_link: "Kopyahin ang link", g_clear: "Burahin",
  gp_title: "Preview ng email na ipapadala sa mga tagapangalaga",
  gp_hello: "Kumusta",
  gp_name_ph: "[Pangalan ng tagapangalaga]",
  gp_designated: "ay nagtalaga sa iyo bilang tagapangalaga ng kanyang kandila ng alaala.",
  gp_unique: "🔒 Natatangi at pribado ang link na ito: para lang ito sa iyo. Huwag ibahagi kahit kanino.",
  gp_three: "Sa takdang panahon, kailangan ng aktibasyon ng lahat ng tatlong tagapangalaga para makumpirma ang pagpanaw. Bawat isa ay may sariling ligtas na link at dapat kumpirmahin sa kanyang panig.",
  gp_thanks: "Sa pamamagitan ng link na ito, makukumpirma mo ang pagpanaw sa takdang panahon:",
  gp_access: "I-access ang parangal",
  gp_free: "✅ Ang buong proseso ay ganap na libre at mahigpit na kumpidensyal.",
  gp_keep: "Ingatan mo ang link na ito.",
  gp_send: "Kumpirmahin ang pagpapadala sa mga tagapangalaga",
  gp_you: "Ikaw",
  ga_guard: "I-validate muna ang lahat ng hakbang (dapat berde lahat) bago i-activate ang mga tagapangalaga.",
  ga_confirm_send: "Kinukumpirma mo ba ang pagpapadala ng email na ito sa lahat ng tagapangalaga? (ika-2 kumpirmasyon)",
};
const ru = {
  b_step_photo: "Фото", b_step_identity: "Личность", b_step_message: "Сообщение",
  b_intro: "Заполните информацию о свече точно так же, как при создании свечи на сайте.",
  b_photo_hint: "Фото свечи (по умолчанию: ваше фото профиля) · макс. 3 МБ",
  b_name: "Имя (или фамилия)", b_name_ph: "Имя человека, которого чтите",
  b_birth: "Дата рождения", b_death: "Дата смерти",
  b_nationality: "Гражданство", b_choose: "— Выбрать —",
  b_message: "Сообщение / дань памяти", b_message_ph: "Оставьте сообщение для всех, кто вам напишет",
  g_step_designate: "Назначить", g_step_send: "Отправить ссылки", g_step_publish: "Публикация",
  g_why_title: "Зачем назначать поручителей?",
  g_why_1: "Ваши поручители — это ваши доверенные люди.",
  g_why_2: "Когда придёт время, три поручителя подтверждают кончину по защищённой ссылке, полученной по e-mail. После проверки администратор Postinity отправит сохранённые послания.",
  g_why_3: "Вы можете изменить поручителей в любой момент.",
  g_designate_3: "Назначьте 3 поручителей", g_guarantor: "Поручитель",
  g_name: "Имя", g_name_ph: "Имя Фамилия", g_email: "E-mail", g_email_ph: "email@primer.ru",
  g_link_sent: "Ссылка отправлена", g_copy_link: "Копировать ссылку", g_clear: "Очистить",
  gp_title: "Предпросмотр письма для поручителей",
  gp_hello: "Здравствуйте",
  gp_name_ph: "[Имя поручителя]",
  gp_designated: "назначил(а) вас поручителем своей свечи памяти.",
  gp_unique: "🔒 Эта ссылка уникальна и строго персональна: она предназначена только вам. Не делитесь ею ни с кем.",
  gp_three: "Когда придёт время, подтверждение кончины обязательно требует активации всех трёх поручителей. Каждый получает свою защищённую ссылку и подтверждает со своей стороны.",
  gp_thanks: "По этой ссылке вы сможете подтвердить кончину, когда придёт время:",
  gp_access: "Открыть дань памяти",
  gp_free: "✅ Вся процедура полностью бесплатна и строго конфиденциальна.",
  gp_keep: "Бережно сохраните эту ссылку.",
  gp_send: "Подтвердить отправку поручителям",
  gp_you: "Вы",
  ga_guard: "Сначала подтвердите все этапы (всё должно быть зелёным), прежде чем активировать поручителей.",
  ga_confirm_send: "Подтверждаете отправку этого письма всем поручителям? (2-е подтверждение)",
};
const el = {
  b_step_photo: "Φωτογραφία", b_step_identity: "Ταυτότητα", b_step_message: "Μήνυμα",
  b_intro: "Συμπληρώστε τις πληροφορίες του κεριού, ακριβώς όπως κατά τη δημιουργία ενός κεριού στον ιστότοπο.",
  b_photo_hint: "Φωτογραφία κεριού (προεπιλογή: η φωτογραφία προφίλ σας) · μέγ. 3 MB",
  b_name: "Όνομα (ή μικρό όνομα)", b_name_ph: "Όνομα του τιμώμενου προσώπου",
  b_birth: "Ημερομηνία γέννησης", b_death: "Ημερομηνία θανάτου",
  b_nationality: "Εθνικότητα", b_choose: "— Επιλέξτε —",
  b_message: "Μήνυμα / φόρος τιμής", b_message_ph: "Αφήστε ένα μήνυμα για όλους όσους θα σας γράψουν",
  g_step_designate: "Ορισμός", g_step_send: "Αποστολή συνδέσμων", g_step_publish: "Δημοσίευση",
  g_why_title: "Γιατί να ορίσετε εγγυητές;",
  g_why_1: "Οι εγγυητές σας είναι τα έμπιστα άτομά σας.",
  g_why_2: "Όταν έρθει η ώρα, οι τρεις εγγυητές επιβεβαιώνουν τον θάνατο μέσω ασφαλούς συνδέσμου που λαμβάνουν με email. Μετά τον έλεγχο, ο διαχειριστής της Postinity θα στείλει τα αποθηκευμένα μηνύματα.",
  g_why_3: "Μπορείτε να αλλάξετε τους εγγυητές σας ανά πάσα στιγμή.",
  g_designate_3: "Ορίστε τους 3 εγγυητές σας", g_guarantor: "Εγγυητής",
  g_name: "Όνομα", g_name_ph: "Όνομα Επώνυμο", g_email: "Email", g_email_ph: "email@paradeigma.gr",
  g_link_sent: "Ο σύνδεσμος στάλθηκε", g_copy_link: "Αντιγραφή συνδέσμου", g_clear: "Καθαρισμός",
  gp_title: "Προεπισκόπηση του email προς τους εγγυητές",
  gp_hello: "Γεια σας",
  gp_name_ph: "[Όνομα εγγυητή]",
  gp_designated: "σας όρισε εγγυητή του κεριού μνήμης του/της.",
  gp_unique: "🔒 Αυτός ο σύνδεσμος είναι μοναδικός και αυστηρά προσωπικός: προορίζεται μόνο για εσάς. Μην τον μοιραστείτε με κανέναν.",
  gp_three: "Όταν έρθει η ώρα, η επιβεβαίωση του θανάτου απαιτεί υποχρεωτικά την ενεργοποίηση και των τριών εγγυητών. Καθένας λαμβάνει τον δικό του ασφαλή σύνδεσμο και πρέπει να επιβεβαιώσει.",
  gp_thanks: "Με αυτόν τον σύνδεσμο θα μπορέσετε να επιβεβαιώσετε τον θάνατο όταν έρθει η ώρα:",
  gp_access: "Πρόσβαση στον φόρο τιμής",
  gp_free: "✅ Όλη η διαδικασία είναι εντελώς δωρεάν και αυστηρά εμπιστευτική.",
  gp_keep: "Φυλάξτε αυτόν τον σύνδεσμο προσεκτικά.",
  gp_send: "Επιβεβαίωση αποστολής στους εγγυητές",
  gp_you: "Εσείς",
  ga_guard: "Επικυρώστε πρώτα όλα τα βήματα (όλα πρέπει να είναι πράσινα) πριν ενεργοποιήσετε τους εγγυητές.",
  ga_confirm_send: "Επιβεβαιώνετε την αποστολή αυτού του email σε όλους τους εγγυητές; (2η επιβεβαίωση)",
};
const hi = {
  b_step_photo: "तस्वीर", b_step_identity: "पहचान", b_step_message: "संदेश",
  b_intro: "मोमबत्ती की जानकारी भरें, ठीक वैसे ही जैसे साइट पर मोमबत्ती बनाते समय।",
  b_photo_hint: "मोमबत्ती की तस्वीर (डिफ़ॉल्ट: आपकी प्रोफ़ाइल फ़ोटो) · अधिकतम 3 MB",
  b_name: "नाम (या पहला नाम)", b_name_ph: "सम्मानित व्यक्ति का नाम",
  b_birth: "जन्म तिथि", b_death: "निधन तिथि",
  b_nationality: "राष्ट्रीयता", b_choose: "— चुनें —",
  b_message: "संदेश / श्रद्धांजलि", b_message_ph: "उन सभी के लिए संदेश छोड़ें जो आपको लिखेंगे",
  g_step_designate: "नियुक्त करें", g_step_send: "लिंक भेजें", g_step_publish: "प्रकाशन",
  g_why_title: "ज़मानतदार क्यों नियुक्त करें?",
  g_why_1: "आपके ज़मानतदार आपके विश्वसनीय लोग हैं।",
  g_why_2: "समय आने पर, आपके तीन ज़मानतदार ईमेल पर मिले सुरक्षित लिंक से निधन की पुष्टि करते हैं। जाँच के बाद, Postinity प्रशासक सहेजे गए संदेश भेजेगा।",
  g_why_3: "आप अपने ज़मानतदार कभी भी बदल सकते हैं।",
  g_designate_3: "अपने 3 ज़मानतदार नियुक्त करें", g_guarantor: "ज़मानतदार",
  g_name: "नाम", g_name_ph: "पहला नाम उपनाम", g_email: "ईमेल", g_email_ph: "email@udaharan.com",
  g_link_sent: "लिंक भेजा गया", g_copy_link: "लिंक कॉपी करें", g_clear: "साफ़ करें",
  gp_title: "ज़मानतदारों को भेजे गए ईमेल का पूर्वावलोकन",
  gp_hello: "नमस्ते",
  gp_name_ph: "[ज़मानतदार का नाम]",
  gp_designated: "ने आपको अपनी स्मृति मोमबत्ती का ज़मानतदार नियुक्त किया है।",
  gp_unique: "🔒 यह लिंक अद्वितीय और पूर्णतः व्यक्तिगत है: यह केवल आपके लिए है। इसे किसी से साझा न करें।",
  gp_three: "समय आने पर, निधन की पुष्टि के लिए तीनों ज़मानतदारों का सक्रिय होना अनिवार्य है। प्रत्येक को अपना सुरक्षित लिंक मिलता है और अपनी ओर से पुष्टि करनी होती है।",
  gp_thanks: "इस लिंक से आप समय आने पर निधन की पुष्टि कर सकेंगे:",
  gp_access: "श्रद्धांजलि तक पहुँचें",
  gp_free: "✅ पूरी प्रक्रिया पूर्णतः मुफ़्त और पूर्णतः गोपनीय है।",
  gp_keep: "इस लिंक को सावधानी से सुरक्षित रखें।",
  gp_send: "ज़मानतदारों को भेजना पुष्टि करें",
  gp_you: "आप",
  ga_guard: "अपने ज़मानतदारों को सक्रिय करने से पहले सभी चरण मान्य करें (सब हरा होना चाहिए)।",
  ga_confirm_send: "क्या आप यह ईमेल सभी ज़मानतदारों को भेजने की पुष्टि करते हैं? (दूसरी पुष्टि)",
};
const ja = {
  b_step_photo: "写真", b_step_identity: "本人情報", b_step_message: "メッセージ",
  b_intro: "サイトでキャンドルを作成するときと同じように、キャンドルの情報を入力してください。",
  b_photo_hint: "キャンドルの写真（既定：プロフィール写真）· 最大 3 MB",
  b_name: "名前（または下の名前）", b_name_ph: "追悼する方のお名前",
  b_birth: "生年月日", b_death: "命日",
  b_nationality: "国籍", b_choose: "— 選択 —",
  b_message: "メッセージ / 追悼", b_message_ph: "あなたに書いてくれるすべての人へメッセージを残しましょう",
  g_step_designate: "指名", g_step_send: "リンクを送る", g_step_publish: "公開",
  g_why_title: "なぜ保証人を指名するのですか？",
  g_why_1: "保証人はあなたの信頼できる方々です。",
  g_why_2: "その時が来たら、3人の保証人がメールで受け取った安全なリンクで逝去を確認します。確認後、Postinity 管理者が保存されたメッセージを送信します。",
  g_why_3: "保証人はいつでも変更できます。",
  g_designate_3: "3人の保証人を指名してください", g_guarantor: "保証人",
  g_name: "名前", g_name_ph: "名 姓", g_email: "メール", g_email_ph: "email@example.jp",
  g_link_sent: "リンクを送信しました", g_copy_link: "リンクをコピー", g_clear: "消去",
  gp_title: "保証人に送るメールのプレビュー",
  gp_hello: "こんにちは",
  gp_name_ph: "[保証人のお名前]",
  gp_designated: "はあなたを追悼キャンドルの保証人に指名しました。",
  gp_unique: "🔒 このリンクは固有で完全に個人用です。あなた専用です。誰とも共有しないでください。",
  gp_three: "その時が来たら、逝去の確認には3人の保証人全員の有効化が必須です。各保証人は自分専用の安全なリンクを受け取り、各自で確認する必要があります。",
  gp_thanks: "このリンクで、その時が来たら逝去を確認できます：",
  gp_access: "追悼にアクセス",
  gp_free: "✅ すべての手続きは完全無料で、厳重に機密です。",
  gp_keep: "このリンクを大切に保管してください。",
  gp_send: "保証人への送信を確認",
  gp_you: "あなた",
  ga_guard: "保証人を有効化する前に、すべてのステップを確定してください（すべて緑になる必要があります）。",
  ga_confirm_send: "このメールをすべての保証人に送信しますか？（2回目の確認）",
};
const zh = {
  b_step_photo: "照片", b_step_identity: "身份", b_step_message: "留言",
  b_intro: "填写蜡烛信息，与在网站上创建蜡烛时完全相同。",
  b_photo_hint: "蜡烛照片（默认：您的头像）· 最大 3 MB",
  b_name: "姓名（或名字）", b_name_ph: "受纪念者的姓名",
  b_birth: "出生日期", b_death: "离世日期",
  b_nationality: "国籍", b_choose: "— 选择 —",
  b_message: "留言 / 悼念", b_message_ph: "为所有将给您写信的人留下一条留言",
  g_step_designate: "指定", g_step_send: "发送链接", g_step_publish: "发布",
  g_why_title: "为什么要指定担保人？",
  g_why_1: "您的担保人是您信任的人。",
  g_why_2: "到时候，您的三位担保人通过邮件收到的安全链接确认离世。核实后，Postinity 管理员将发送已保存的留言。",
  g_why_3: "您可以随时更改担保人。",
  g_designate_3: "指定您的 3 位担保人", g_guarantor: "担保人",
  g_name: "姓名", g_name_ph: "名 姓", g_email: "邮箱", g_email_ph: "email@example.com",
  g_link_sent: "链接已发送", g_copy_link: "复制链接", g_clear: "清除",
  gp_title: "发送给担保人的邮件预览",
  gp_hello: "您好",
  gp_name_ph: "[担保人名字]",
  gp_designated: "已指定您为其纪念蜡烛的担保人。",
  gp_unique: "🔒 此链接唯一且严格私人：仅供您使用。请勿与任何人分享。",
  gp_three: "到时候，确认离世必须由三位担保人全部激活。每位担保人收到各自的安全链接，并须各自确认。",
  gp_thanks: "通过此链接，您可在到时候确认离世：",
  gp_access: "访问悼念",
  gp_free: "✅ 整个过程完全免费且严格保密。",
  gp_keep: "请妥善保管此链接。",
  gp_send: "确认发送给担保人",
  gp_you: "您",
  ga_guard: "在激活担保人之前，请先确认所有步骤（全部必须为绿色）。",
  ga_confirm_send: "确认将此邮件发送给所有担保人？（第二次确认）",
};

export const postinity5 = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
